import {Injectable} from "@angular/core";
import {Chart} from "chart.js";
import {ExportChartImage} from "./export-chart-image";
@Injectable({
  providedIn: 'root'
})

/*
01/09/2025 - Kauan
classe que modifica os gráficos de barra vertical, como o chartjs nessa versão nao permite adicionar
dois textos diferentes pro mesmo label o valor da barra é sobrescrevido usando o ctx

fixei a rotacao em 40 caso o length passe de 6 pq no caso do livro razao, as legendas permanecem horizontais
e os valores invadem um ao outro

a funcao de padding foi feita por interpolacao
 https://www.wolframalpha.com/input?i=InterpolatingPolynomial%5B%7B+%7B50%2C+18%7D%2C+%7B45%2C16%7D%2C+%7B0%2C+12%7D%2C+%7B22%2C+8%7D%7D%2C+x%5D
só pra ficar mais estético

o fluxo do ctx é parecido com o do opengl, pra cada legenda salvamos o estado, transladamos e rotacionamos antes de plotar
 */

export class ProcessBarChart {
  constructor(private exportChartImage: ExportChartImage) {
  }

  process(chart: any, activeLink: string) : void {
    //nao funciona jogar isso dentro do forEach dos datasets por algum motivo....
    if(chart.data.datasets[0].data.length> 6){
      chart.options.scales.xAxes[0].ticks.minRotation = 40;
      chart.update();
    }
    chart.options.layout.padding.bottom = 20;
    chart.options.animation.duration = 1;

    chart.options.animation.onComplete = () => {
      const ctx = chart.ctx;
      ctx.font = Chart.helpers.fontString(
        10,
        Chart.defaults.global.defaultFontStyle,
        Chart.defaults.global.defaultFontFamily
      );

      ctx.textAlign = 'center';
      ctx.fillStyle = '#111111';
      ctx.textBaseline = 'bottom';
      chart.data.datasets.forEach((dataset: any) => {
        for (let i = 0; i < dataset.data.length; i++){
          ctx.save()
          const meta = dataset._meta[Object.keys(dataset._meta)[0]];
          const model = meta.data[i]._model;
          if (chart.data.datasets.length > 6){
            meta.data[i]._xScale.labelRotation = 40;
          }
          ctx.translate(model.x -2, (chart.height - meta.data[i]._xScale.height) + this.paddingFunction(meta.data[i]._xScale.labelRotation));
          const toRadNeg = (n : number) => (n * (Math.PI / 180) * -1);
          ctx.rotate(toRadNeg(meta.data[i]._xScale.labelRotation)); //rotaciona o valor pro angulo da legenda
          ctx.fillText(this.prepareValueText(dataset, i, activeLink), 0, 0);
          ctx.restore();
        }
      });
    };
    chart.update();

    setTimeout( () =>{
      this.exportChartImage.save('myChart1');
    }, 100);

    setTimeout( () =>{
      this.undoChanges(chart);
    }, 1000);
  }

  prepareValueText(dataset: any, i: number, activeLink: string) : string {
      if (activeLink === "Despesa"){
        return this.addMinus(new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(dataset.data[i]));
      }
      else {
        return new Intl.NumberFormat('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        }).format(dataset.data[i]);
      }
  }

  addMinus(outlay: string ) : string{
    return outlay.substring(0, 3) + "-" + outlay.substring(3);
  }

  //fiz por interpolacao, 0 graus tem q retornar 12, 22 graus 8, 50 graus 18 e 45 graus 16
  paddingFunction(number : number)  : number{
    return 18 + (2/5 + (3/1610 - (1579*(-22 + number))/7969500)*(-45 + number))*(-50 + number);
  }

  undoChanges(chart: any) : void {
    chart.options.layout.padding.top = 0;
    chart.options.animation.duration = 30;
    chart.options.scales.xAxes[0].ticks.maxRotation = 50;
    chart.options.scales.xAxes[0].ticks.minRotation = 0;
    chart.options.animation.onComplete = function () {};
    chart.update();
  }
}
